<template>
    <form>
        <b-modal :active.sync="isComponentModalActive"
                 has-modal-card full-screen >

            <div class="modal-card ">
                <section class="modal-card-body"  >
                    <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
                    <template>
                        <section>


                            <div class="container">


                                <nav class="level">
                                    <div class="level-left">
                                        <div class="level-item">
                                            <h2 class="subtitle has-text-weight-bold">{{datNews.title}}</h2>
                                        </div>

                                    </div>
                                </nav>

                                <nav class="level">
                                    <div class="level-left">
                                        <div class="level-item">
                                            <p class="is-size-6"> {{datNews.user_rec}} {{ datNews.date_rec }} {{datNews.time_rec}}</p>
                                        </div>
                                    </div>
                                </nav>


                                <figure class="image  is-4by3 ">
                                    <img :src="getImgUrl(datNews.images) " alt="">
                                </figure>

                                <div v-html="datNews.descptoin_html"></div>




                            </div>






                        </section>
                    </template>


                </section>
                <footer class="modal-card-foot">
                    <b-button size="is-medium" type="is-danger"
                              icon-left="close" @click="closeModal">
                        Close
                    </b-button>
                </footer>
            </div>

        </b-modal>
    </form>
</template>

<script>
    import {getBaseURLLabNews}  from '@/utils.js'
    export default {
        name: "ViewNews",
        props:{
          datNews : Object
        },
        methods:{
            getImgUrl(img) {
                return `${getBaseURLLabNews()}/${img}`
                // return `https://picsum.photos/id/43${id}/1230/500`
            },
            closeModal(){
                this.isComponentModalActive = false
            }
        },
        data(){
            return {
                isComponentModalActive : false,
                isFullScreenLoading : false
            }
        }
    }
</script>

<style scoped>
    img{
        width:100%;
        height:100%;
        object-fit: contain;
    }
</style>